"use strict";
/**
 * 路演组件  前端
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Luyan = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var qqzs_1 = require("../shared/qqzs");
var context_1 = require("../context");
require("../shared/css/comm.less");
var luyan_1 = require("../../../modules/api/luyan");
var text_1 = require("./text");
var video_1 = require("./video");
var headerconfig_1 = require("../shared/header/headerconfig");
var header_1 = require("../shared/header");
var fakes_1 = require("./fakes");
var tiptoast_1 = __importDefault(require("../../../modules/modal/tiptoast"));
var user_1 = __importDefault(require("../../../modules/user"));
/**
 * 文字&视频 入口
 * @param props
 * @returns
 */
function Luyan(props) {
    var _this = this;
    var _a = (0, react_1.useState)([]), headerInfo = _a[0], setHeaderInfo = _a[1];
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var colunmset, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, headerconfig_1.getHeaderConfigInfo)()];
                    case 1:
                        colunmset = _a.sent();
                        setHeaderInfo(colunmset);
                        return [4 /*yield*/, (0, luyan_1.getlkAccessInfo)()];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(header_1.IndexHeader, { data: headerInfo, pagename: "luyan" }),
        react_1.default.createElement("div", { className: "main-content" },
            react_1.default.createElement(qqzs_1.QQZS, null),
            react_1.default.createElement(LuyanInner, { luyan_id: props.luyan_id }))));
}
exports.Luyan = Luyan;
function LuyanInner(props) {
    var _this = this;
    var _a;
    var _b = (0, react_1.useState)(null), baseinfo = _b[0], SetBaseInfo = _b[1];
    // console.log(props.luyan_id)
    // 基础数据
    var getData = function () { return __awaiter(_this, void 0, void 0, function () {
        var info;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, luyan_1.getLuyanBaseInfo)(props.luyan_id)];
                case 1:
                    info = _a.sent();
                    if (info != null) {
                        SetBaseInfo(info);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // 黑名单验证
    var checkBlack = function () { return __awaiter(_this, void 0, void 0, function () {
        var res;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, luyan_1.getBlackUserlist)(window.urlid, (_a = user_1.default.get()) === null || _a === void 0 ? void 0 : _a.id)];
                case 1:
                    res = _b.sent();
                    ////黑名单处理
                    if (res === null || res === void 0 ? void 0 : res.no_entering) {
                        tiptoast_1.default.show({
                            content: "您已被踢出直播间",
                            callback: function () {
                                window.location.href = "http://roadshow.eastmoney.com/";
                            }
                        });
                        return [2 /*return*/];
                    }
                    ;
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        // 黑名单校验
        checkBlack();
        // 获取基础数据
        getData();
        var cb = setInterval(function () {
            getData();
        }, 60 * 1000);
        return (function () {
            clearInterval(cb);
        });
    }, []);
    if (!baseinfo)
        return react_1.default.createElement(fakes_1.FakeLuyanInner, null);
    if (baseinfo && baseinfo.type == 1) {
        return react_1.default.createElement(text_1.TextLuyan, { baseinfo: baseinfo });
    }
    else if (baseinfo) {
        return react_1.default.createElement(video_1.VedioLuyan, { baseinfo: baseinfo, uid: (_a = user_1.default.get()) === null || _a === void 0 ? void 0 : _a.id });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null));
}
react_dom_1.default.render(react_1.default.createElement(context_1.MyContext.Provider, { value: { plat: "web" } },
    react_1.default.createElement(Luyan, { luyan_id: window.luyan_id })), document.getElementById('app'));
//# sourceMappingURL=data:application/json;base64,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